import type { BillingRate } from "@/lib/api";
import { BILLING_EVENT_TYPE_LABELS, formatUnitRate, type BillingRateGroup } from "@/lib/billing";

// 利用ガイドの料金ページの単価表の部品 (データは useBillingRates)。

/** カテゴリ 1 件分の単価の行。内訳 (モデルなど) があればその名前で小見出しを立てる。 */
export function BillingRateGroups({ groups }: { groups: readonly BillingRateGroup[] }) {
	return (
		<div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
			{groups.map((group) => (
				<div key={group.key} style={{ display: "flex", flexDirection: "column", gap: 4 }}>
					{group.label !== null && group.label !== "" && (
						<span
							style={{ fontSize: "var(--text-caption)", fontWeight: 600, color: "var(--fg-2)" }}
						>
							{group.label}
						</span>
					)}
					{group.rates.map((rate) => (
						<BillingRateRow key={`${group.key}:${rate.eventType}`} rate={rate} />
					))}
				</div>
			))}
		</div>
	);
}

/** 単価 1 行。左にメータ名、右に「クレジット / 単位」。 */
function BillingRateRow({ rate }: { rate: BillingRate }) {
	const { credits, unit } = formatUnitRate(rate.eventType, rate.unitPriceCredits);
	return (
		<div
			data-testid={`billing-rate-${rate.variantKey ?? "all"}-${rate.eventType}`}
			style={{ display: "flex", alignItems: "baseline", justifyContent: "space-between", gap: 12 }}
		>
			<span
				style={{
					fontSize: "var(--text-caption)",
					color: "var(--fg-1)",
				}}
			>
				{BILLING_EVENT_TYPE_LABELS[rate.eventType] ?? rate.eventType}
			</span>
			<span
				style={{
					flexShrink: 0,
					fontSize: "var(--text-caption)",
					fontWeight: 600,
					color: "var(--fg-1)",
					fontVariantNumeric: "tabular-nums",
				}}
			>
				{credits}
				<span
					style={{
						fontSize: "var(--text-caption)",
						fontWeight: 500,
						color: "var(--fg-1)",
						marginLeft: 4,
					}}
				>
					クレジット {unit}
				</span>
			</span>
		</div>
	);
}
